import { render, staticRenderFns } from "./formGeneral.vue?vue&type=template&id=6f36307e&"
import script from "./formGeneral.vue?vue&type=script&lang=js&"
export * from "./formGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports